// extracted by mini-css-extract-plugin
export default {"container":"Country_container__dyL8O","flagandinfos":"Country_flagandinfos__9XC9h","flag":"Country_flag__w6M6H","flagimg":"Country_flagimg__wOYoN","info":"Country_info__qyv5b"};